<div class="flex flex-column overflow-hidden flex-1 flex h-full">
    <router-outlet></router-outlet>
</div>
